module.exports = __webpack_public_path__ + "img/juegos_btn.bbc7ca26.png";